function isValidEmail(email) {
  if (!email) {
    return false;
  }
  return /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Z]{2,}$/i.test(email);
}

export default isValidEmail;
